"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _react = _interopRequireDefault(require("react"));
var _definitions = require("@ppay/definitions");
var _reactI18next = require("react-i18next");
var _reactResponsive = require("react-responsive");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../../utils");
var _ui = require("../../ui");
var _ticker = require("../../ticker");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var searchIcon = function searchIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.031 14.617L20.314 18.899L18.899 20.314L14.617 16.031C13.0237 17.3082 11.042 18.0029 9 18C4.032 18 0 13.968 0 9C0 4.032 4.032 0 9 0C13.968 0 18 4.032 18 9C18.0029 11.042 17.3082 13.0237 16.031 14.617ZM14.025 13.875C15.2941 12.5699 16.0029 10.8204 16 9C16 5.132 12.867 2 9 2C5.132 2 2 5.132 2 9C2 12.867 5.132 16 9 16C10.8204 16.0029 12.5699 15.2941 13.875 14.025L14.025 13.875Z",
    fill: "#25253E"
  }));
};
searchIcon.defaultProps = {
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Row = (0, _styledComponents.default)(_ui.Row)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 10px;\n  margin-left: -10px;\n  margin-right: -10px;\n"])));
var Button = (0, _styledComponents.default)(_ui.Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", " {\n    margin-left: 0;\n  }\n"])), _utils.mediaQuery.lessThan('sm')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    width: 40px;\n  "]))), _ui.Svg);
var TextButton = _styledComponents.default.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border: none;\n  background: none;\n  display: flex;\n  align-items: center;\n  text-wrap: nowrap;\n  padding: 0;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});
var Spinner = (0, _styledComponents.default)(_ui.Spinner)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-left: 5px;\n"])));
var TextButtonsWrapper = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 10px;\n"])));
var FilterHeader = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n"])));
var Col = (0, _styledComponents.default)(_ui.Col)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin-bottom: 10px;\n  padding-left: 10px;\n  padding-right: 10px;\n"])));
var NoRightPaddingMdCol = (0, _styledComponents.default)(Col)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  padding-right: 10px;\n  ", "\n"])), _utils.mediaQuery.greaterThan('md')(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    padding-right: 0;\n  "]))));
var ButtonCol = (0, _styledComponents.default)(Col)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  padding-left: 0;\n  ", "\n"])), _utils.mediaQuery.greaterThan('md')(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    padding-left: 10px;\n  "]))));
var AmountTitle = (0, _styledComponents.default)(_ui.P)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 10px;\n  margin-bottom: 0;\n"])));
var AmountsSeparator = (0, _styledComponents.default)(_ui.P)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  margin: -5px 10px 0 10px;\n"])));
var Header = function Header(_ref2) {
  var tickers = _ref2.tickers,
    type = _ref2.type,
    onTickersChange = _ref2.onTickersChange,
    onTypeChange = _ref2.onTypeChange,
    paymentTypeOptions = _ref2.paymentTypeOptions,
    onSearchInputChange = _ref2.onSearchInputChange,
    onSearchClick = _ref2.onSearchClick,
    onReset = _ref2.onReset,
    searchValue = _ref2.searchValue,
    isLoading = _ref2.isLoading,
    isCSVLoading = _ref2.isCSVLoading,
    dates = _ref2.dates,
    onDateChange = _ref2.onDateChange,
    setMinAmount = _ref2.setMinAmount,
    setMaxAmount = _ref2.setMaxAmount,
    maxAmount = _ref2.maxAmount,
    minAmount = _ref2.minAmount,
    amountsInvalid = _ref2.amountsInvalid,
    onDownload = _ref2.onDownload;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransactionsTable'),
    t = _useTranslation.t;
  var isTable = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.md
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(FilterHeader, null, /*#__PURE__*/_react.default.createElement(_ui.Label, {
    className: "mb-0"
  }, t('filters'), ":"), /*#__PURE__*/_react.default.createElement(TextButtonsWrapper, null, /*#__PURE__*/_react.default.createElement(TextButton, {
    onClick: onDownload,
    disabled: isCSVLoading
  }, t('downloadCSV'), " ", isCSVLoading ? /*#__PURE__*/_react.default.createElement(Spinner, {
    color: "primary",
    size: "sm"
  }) : '🧾'), /*#__PURE__*/_react.default.createElement(TextButton, {
    onClick: onReset
  }, t('resetFilters')))), /*#__PURE__*/_react.default.createElement(Row, null, /*#__PURE__*/_react.default.createElement(NoRightPaddingMdCol, {
    className: "order-0",
    xs: '',
    md: 10
  }, /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.SearchInputGroupAddon, {
    onClick: isLoading ? function () {} : onSearchClick,
    addonType: "prepend"
  }), /*#__PURE__*/_react.default.createElement(_ui.Input, {
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') onSearchClick();
    },
    value: searchValue,
    onChange: onSearchInputChange,
    placeholder: t('search')
  }))), /*#__PURE__*/_react.default.createElement(ButtonCol, {
    className: "order-1",
    xs: 'auto',
    md: 2
  }, /*#__PURE__*/_react.default.createElement(Button, {
    color: "secondary",
    onClick: onSearchClick,
    loading: isLoading,
    icon: isTable ? /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: searchIcon,
      size: 15
    }) : null
  }, isTable ? '' : t('searchButton'))), /*#__PURE__*/_react.default.createElement(NoRightPaddingMdCol, {
    className: "order-2 order-md-2",
    xs: 12,
    md: 4,
    lg: 3
  }, /*#__PURE__*/_react.default.createElement(_ticker.TickerMultiSelectInput, {
    value: tickers,
    tickers: [].concat(_toConsumableArray(_definitions.CRYPTO_TICKERS), _toConsumableArray(_definitions.FIAT_BALANCE_TICKERS)),
    onChange: onTickersChange
  })), /*#__PURE__*/_react.default.createElement(NoRightPaddingMdCol, {
    className: "order-3 order-md-3",
    xs: 12,
    md: 4,
    lg: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.SelectInput, {
    placeholder: t('paymentType'),
    value: type !== null && type !== void 0 ? type : paymentTypeOptions[0].value,
    defaultValue: paymentTypeOptions[0].value,
    onChange: function onChange(value) {
      return onTypeChange(value);
    },
    options: paymentTypeOptions
  })), /*#__PURE__*/_react.default.createElement(Col, {
    className: "order-4 order-md-4",
    xs: 12,
    md: 4,
    lg: 3
  }, /*#__PURE__*/_react.default.createElement(_ui.DateRangePicker, {
    value: dates,
    onChange: onDateChange,
    maxDate: new Date(),
    placeholder: t('allDate'),
    isClearable: true
  })), /*#__PURE__*/_react.default.createElement(Col, {
    className: "order-5 d-flex",
    xs: 12,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(AmountTitle, null, t('range.title')), /*#__PURE__*/_react.default.createElement(_ui.NumberFormatInput, {
    value: minAmount,
    decimals: 18,
    onChange: function onChange(e) {
      return setMinAmount(e.target.value);
    },
    placeholder: t('range.min'),
    invalid: amountsInvalid
  }), /*#__PURE__*/_react.default.createElement(AmountsSeparator, {
    className: "h-100 d-flex align-items-center"
  }, "-"), /*#__PURE__*/_react.default.createElement(_ui.NumberFormatInput, {
    value: maxAmount,
    decimals: 18,
    onChange: function onChange(e) {
      return setMaxAmount(e.target.value);
    },
    placeholder: t('range.max'),
    invalid: amountsInvalid
  }))));
};
exports.Header = Header;